import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "copy";
const pathData = "M409.5 103q33 0 55 22.5t22 54.5v256q0 32-22 54t-55 22h-204q-33 0-55-22t-22-54V180q0-32 22-54.5t55-22.5h204zm26 77q0-11-7.5-18.5t-18.5-7.5h-204q-12 0-19 7.5t-7 18.5v256q0 25 26 25h204q11 0 18.5-7t7.5-18V180zm-77 179q11 0 18.5 7t7.5 18q0 12-7.5 19t-18.5 7h-102q-26 0-26-26 0-25 26-25h102zm0-77q11 0 18.5 7t7.5 19q0 11-7.5 18t-18.5 7h-102q-26 0-26-25 0-26 26-26h102zm26-255q0 11-7.5 18t-18.5 7h-256q-25 0-25 26v306q0 26-26 26-25 0-25-26V78q0-33 22-55t54-22h256q11 0 18.5 7t7.5 19z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/copy";
export { pathData, ltr, accData };